import { StringValidation } from '../../../../../utils/component-validations';
import FlexRow from '../../../layout/flex/row.gjs';
import Super from '../../../core/base.gjs';

export default class SpdsFeedbackAlertBannerMessageBody extends Super {
  arguments = [new StringValidation({ required: ['body'] })];
  baseClass = 'spds-alert-banner-message-body spds-feedback-alert-banner-message-body';
  componentName = 'Spds::AlertBanner::Message::Body';

  <template>
    <FlexRow
      @content={{@body}}
      class={{this.classes}}
      data-test-spds-alert-banner-message-body
      {{this.validateArguments}}
      ...attributes
    />
  </template>
}
